import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "w-full es-person-form-div" }
const _hoisted_6 = { class: "row w-full" }
const _hoisted_7 = ["src"]

import { watch, ref } from "vue";
import { AdminApi, ApiError, FinancialGroupLightResponse, MedicalPersonFinancialGroupResponse } from '@/apiGenerate/medserver';
import { useI18n } from "vue-i18n";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { useToast } from "primevue";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { FilterMatchMode } from '@primevue/core/api';
import SharedService from "@/services/SharedService";
import { SctLanguageItem } from "@/models/share.model";
import Tag from 'primevue/tag';
import EsPersonFinancialGroupForm from '@/components/form/admin/esPersonFinancialGroupForm.vue';
import ToggleSwitch from 'primevue/toggleswitch';
import EsConfirmDialog from '@/components/modals/esConfirmDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esManagePersonFinancialGroup',
  props: {
    isOpen: { type: Boolean },
    currentFinancialGroup: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const adminApi = new AdminApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();

const emits = __emit;

const medicalPersonList = ref<MedicalPersonFinancialGroupResponse[]>([]);
const isConfirmModalOpen = ref<boolean>(false);
const isOwnerUpdated = ref<boolean>(true);
const medicalPersonFinancialGroupUpdated = ref<MedicalPersonFinancialGroupResponse>(undefined);
const isDeleteModalOpen = ref<boolean>(false);
const confirmDeleteMessage = ref<string>(t('admin.financialGroup.person.delete.modale.message'));

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const loading = ref(true);

const dataTableColumns = [
    { field: 'name', header: t('admin.financialGroup.person.table.name') },
    { field: 'role', header: t('admin.financialGroup.person.table.role') },
    { field: 'active', header: t('admin.financialGroup.person.table.active') },
    { field: 'isOwner', header: t('admin.financialGroup.person.table.isOwner') },
    { field: 'action', header: t('admin.financialGroup.person.table.delete')}
];

const getAllMedicalPersonByCommonFinancialGroup =async  () => {
  if (props.currentFinancialGroup && props.currentFinancialGroup.id) {
   await adminApi.getAllMedicalPersonByCommonFinancialGroup({financialGroupId: props.currentFinancialGroup.id}).then((res: MedicalPersonFinancialGroupResponse[]) => {
        medicalPersonList.value = res.sort((a, b) => {
            const nameCompare = a.name.localeCompare(b.name, SctLanguageItem.FrFr, { sensitivity: 'base' });

            if (nameCompare !== 0) {
                return nameCompare;
            }

            return a.name.localeCompare(b.name, SctLanguageItem.FrFr, { sensitivity: 'base' });
        });

        loading.value = false;
    }).catch((error: ApiError) => {
        toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
    });
  }
}

const updateIsOwner = (isOwner: boolean, medicalPersonFinancialGroupResponse: MedicalPersonFinancialGroupResponse) => {
    isOwnerUpdated.value = isOwner;
    medicalPersonFinancialGroupUpdated.value = medicalPersonFinancialGroupResponse;

    if (medicalPersonList.value.find((existPerson) => existPerson.isOwner && existPerson.id !== medicalPersonFinancialGroupUpdated.value.id)) {
        isConfirmModalOpen.value = true;
    } else {
        closeConfirmModal();
    }
}

const removeUpdatedData = async () => {
    isConfirmModalOpen.value = false;
    isOwnerUpdated.value = false;
    medicalPersonFinancialGroupUpdated.value = undefined;

    await getAllMedicalPersonByCommonFinancialGroup();
}

const closeConfirmModal = () => {
    if (medicalPersonFinancialGroupUpdated.value) {
        adminApi.updateMedicalPersonInCommonFinancialGroup({financialGroupId: props.currentFinancialGroup.id, personId: medicalPersonFinancialGroupUpdated.value.id, isOwner: isOwnerUpdated.value})
        .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.update'),
                detail:  t('admin.financialGroup.person.update.message.success')
            });
            
            removeUpdatedData();
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });

            // Throw error to set at false the var __alreadyClicked in v-one-click directive
            throw error;
        });
    }
}

const openDeleteModal = (medicalPersonFinancialGroupResponse: MedicalPersonFinancialGroupResponse) => {
    isDeleteModalOpen.value = true;
    medicalPersonFinancialGroupUpdated.value = medicalPersonFinancialGroupResponse;
    confirmDeleteMessage.value = medicalPersonFinancialGroupResponse.isOwner ? t('admin.financialGroup.person.delete.modale.messageOwner') : t('admin.financialGroup.person.delete.modale.message')
}

const closeDeleteConfirmModal = () => {
  if (medicalPersonFinancialGroupUpdated.value) {
    adminApi.deleteMedicalPersonInCommonFinancialGroup({financialGroupId: props.currentFinancialGroup.id, personId: medicalPersonFinancialGroupUpdated.value.id})
        .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.delete'),
                detail:  t('admin.financialGroup.person.delete.message.success')
            });
            getAllMedicalPersonByCommonFinancialGroup();
            isDeleteModalOpen.value = false;
            medicalPersonFinancialGroupUpdated.value = undefined;
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });

            // Throw error to set at false the var __alreadyClicked in v-one-click directive
            throw error;
        });
  }
};

const confirmFormModal = () => {
  emits('modal-close');
}

const clearFilter = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
};

watch(
    () => props.isOpen,
   () => {
    if (props.currentFinancialGroup) {
      getAllMedicalPersonByCommonFinancialGroup();
    }
  }
)


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_es_modal_header, {
                header: _unref(t)('admin.financialGroup.person.title', {title: _ctx.currentFinancialGroup.title})
              }, null, 8, ["header"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(EsPersonFinancialGroupForm, {
                    "exist-person-list": medicalPersonList.value,
                    "current-financial-group-id": _ctx.currentFinancialGroup.id,
                    onRefresh: _cache[0] || (_cache[0] = ($event: any) => (getAllMedicalPersonByCommonFinancialGroup()))
                  }, null, 8, ["exist-person-list", "current-financial-group-id"])
                ]),
                _createVNode(_unref(DataTable), {
                  filters: filters.value,
                  "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
                  dataKey: "id",
                  globalFilterFields: ['name'],
                  loading: loading.value,
                  value: medicalPersonList.value,
                  stripedRows: "",
                  paginator: "",
                  rows: 5,
                  class: "w-full"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(IconField), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(InputIcon), null, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                                class: "img-grey"
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(InputText), {
                            modelValue: filters.value['global'].value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                            placeholder: _unref(t)('admin.financialGroup.person.search')
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createVNode(_unref(InputIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_es_button_icon, {
                                icon: "xmark",
                                folder: "shareIcons",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                                styles: "img-grey"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.financialGroup.person.table.empty')), 1)
                  ]),
                  loading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataTableColumns, (col) => {
                      return _createElementVNode("div", {
                        key: col.field
                      }, [
                        (col.field !== 'active' && col.field !== 'isOwner' && col.field !== 'action')
                          ? (_openBlock(), _createBlock(_unref(Column), {
                              key: col.field,
                              field: col.field,
                              header: col.header,
                              sortable: ""
                            }, null, 8, ["field", "header"]))
                          : _createCommentVNode("", true)
                      ])
                    }), 64)),
                    _createVNode(_unref(Column), {
                      field: 'active',
                      header:  _unref(t)('admin.financialGroup.person.table.active')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_unref(Tag), {
                          severity: slotProps.data.active ? 'success' : 'warn',
                          value: slotProps.data.active ? _unref(t)('common.status.active') : _unref(t)('common.status.unactive')
                        }, null, 8, ["severity", "value"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), {
                      field: 'isOwner',
                      header:  _unref(t)('admin.financialGroup.person.table.isOwner')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_unref(ToggleSwitch), {
                          modelValue: slotProps.data.isOwner,
                          "onUpdate:modelValue": ($event: any) => (updateIsOwner($event, slotProps.data))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), {
                      field: 'action',
                      header: _unref(t)('admin.financialGroup.person.table.delete')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_es_button_icon, {
                          icon: "trash",
                          folder: "settings",
                          class: "pad-l",
                          styles: "img-primary",
                          onClick: ($event: any) => (openDeleteModal(slotProps.data))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["header"])
                  ]),
                  _: 1
                }, 8, ["filters", "loading", "value"])
              ]),
              _createVNode(_component_es_modal_footer, {
                displayCancel: false,
                confirmLabel: 'action.close',
                confirmModalMethod: confirmFormModal
              })
            ], 512)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(EsConfirmDialog, {
      isOpen: isConfirmModalOpen.value,
      header: _unref(t)('admin.financialGroup.person.update.header.confirm'),
      message: _unref(t)('admin.financialGroup.person.form.ownerWarning'),
      onModalClose: removeUpdatedData,
      "on-confirm": closeConfirmModal
    }, null, 8, ["isOpen", "header", "message"]),
    _createVNode(EsConfirmDialog, {
      isOpen: isDeleteModalOpen.value,
      header: _unref(t)('admin.financialGroup.person.delete.modale.header'),
      message: confirmDeleteMessage.value,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (isDeleteModalOpen.value = false)),
      "on-confirm": closeDeleteConfirmModal
    }, null, 8, ["isOpen", "header", "message"])
  ], 64))
}
}

})